export default {
      id: "shoulder-left-usage",
      viewBox: "0 0 26 41",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#shoulder-left",
      toString: function () {
        return this.url;
      }
    }